import TenantAssetsService, { getCreditsImage, getLogoImage, getLogoMobile } from './TenantAssetsService.js'

import arrowDownSvgUrl from './assets/svg/arrow-down.svg'
import arrowUpSvgUrl from './assets/svg/arrow-up.svg'
import blendSvgUrl from './assets/svg/blend.svg'
import blendGreySvgUrl from './assets/svg/blend-grey.svg'
import closeSvgUrl from './assets/svg/close.svg'
import defaultPoiSvgUrl from './assets/svg/default-poi.svg'
import fullScreenSvgUrl from './assets/svg/full-screen.svg'
import fullScreenExitSvgUrl from './assets/svg/full-screen-exit.svg'
import globalNavigationSvgUrl from './assets/svg/global-navigation.svg'
import goToEndSvgUrl from './assets/svg/go-to-end.svg'
import goToStartSvgUrl from './assets/svg/go-to-start.svg'
import haltaActivePoiSvgUrl from './assets/svg/halta-active-poi.svg'
import haltaActivePovSvgUrl from './assets/svg/halta-active-pov.svg'
import haltaDefaultPoiSvgUrl from './assets/svg/halta-default-poi.svg'
import haltaDefaultPovSvgUrl from './assets/svg/halta-default-pov.svg'
import homeSvgUrl from './assets/svg/home.svg'
import indexSvgUrl from './assets/svg/index.svg'
import infoSvgUrl from './assets/svg/info.svg'
import markerSvgUrl from './assets/svg/marker.svg'
import markerSelectedSvgUrl from './assets/svg/marker-selected.svg'
import modeContainerSvgUrl from './assets/svg/mode-container.svg'
import modeContainerGreySvgUrl from './assets/svg/mode-container-grey.svg'
import modeLayersSvgUrl from './assets/svg/mode-layers.svg'
import modeLayersGreySvgUrl from './assets/svg/mode-layers-grey.svg'
import modePointersplitSvgUrl from './assets/svg/mode-pointersplit.svg'
import modePointersplitGreySvgUrl from './assets/svg/mode-pointersplit-grey.svg'
import nextSvgUrl from './assets/svg/next.svg'
import nextGreySvgUrl from './assets/svg/next-grey.svg'
import nextStepSvgUrl from './assets/svg/nextStep.svg'
import onPremisesHomeSvgUrl from './assets/svg/on-premises-home.svg'
import plusSvgUrl from './assets/svg/plus.svg'
import prevSvgUrl from './assets/svg/prev.svg'
import prevGreySvgUrl from './assets/svg/prev-grey.svg'
import prevStepSvgUrl from './assets/svg/prevStep.svg'
import rotateSvgUrl from './assets/svg/rotate.svg'
import rotateRightSvgUrl from './assets/svg/rotate-right.svg'
import rulerSvgUrl from './assets/svg/ruler.svg'
import storySvgUrl from './assets/svg/story.svg'
import zoomInSvgUrl from './assets/svg/zoom-in.svg'
import zoomInGreySvgUrl from './assets/svg/zoom-in-grey.svg'
import zoomOutSvgUrl from './assets/svg/zoom-out.svg'
import zoomOutGreySvgUrl from './assets/svg/zoom-out-grey.svg'

const svgIconUrlMap = {
  'arrow-down.svg': arrowDownSvgUrl,
  'arrow-up.svg': arrowUpSvgUrl,
  'blend.svg': blendSvgUrl,
  'blend-grey.svg': blendGreySvgUrl,
  'close.svg': closeSvgUrl,
  'default-poi.svg': defaultPoiSvgUrl,
  'full-screen.svg': fullScreenSvgUrl,
  'full-screen-exit.svg': fullScreenExitSvgUrl,
  'global-navigation.svg': globalNavigationSvgUrl,
  'go-to-end.svg': goToEndSvgUrl,
  'go-to-start.svg': goToStartSvgUrl,
  'halta-active-poi.svg': haltaActivePoiSvgUrl,
  'halta-active-pov.svg': haltaActivePovSvgUrl,
  'halta-default-poi.svg': haltaDefaultPoiSvgUrl,
  'halta-default-pov.svg': haltaDefaultPovSvgUrl,
  'home.svg': homeSvgUrl,
  'index.svg': indexSvgUrl,
  'info.svg': infoSvgUrl,
  'marker.svg': markerSvgUrl,
  'marker-selected.svg': markerSelectedSvgUrl,
  'mode-container.svg': modeContainerSvgUrl,
  'mode-container-grey.svg': modeContainerGreySvgUrl,
  'mode-layers.svg': modeLayersSvgUrl,
  'mode-layers-grey.svg': modeLayersGreySvgUrl,
  'mode-pointersplit.svg': modePointersplitSvgUrl,
  'mode-pointersplit-grey.svg': modePointersplitGreySvgUrl,
  'next.svg': nextSvgUrl,
  'next-grey.svg': nextGreySvgUrl,
  'nextStep.svg': nextStepSvgUrl,
  'on-premises-home.svg': onPremisesHomeSvgUrl,
  'plus.svg': plusSvgUrl,
  'prev.svg': prevSvgUrl,
  'prev-grey.svg': prevGreySvgUrl,
  'prevStep.svg': prevStepSvgUrl,
  'rotate.svg': rotateSvgUrl,
  'rotate-right.svg': rotateRightSvgUrl,
  'ruler.svg': rulerSvgUrl,
  'story.svg': storySvgUrl,
  'zoom-in.svg': zoomInSvgUrl,
  'zoom-in-grey.svg': zoomInGreySvgUrl,
  'zoom-out.svg': zoomOutSvgUrl,
  'zoom-out-grey.svg': zoomOutGreySvgUrl
}

export const getSvgIcon = fileName => {
  const iconUrl = svgIconUrlMap[fileName]
  if (!iconUrl) {
    console.warn(`Assets Service - SVG not found in bundle: ${fileName}`)
    return ''
  }
  return iconUrl
}

export { getCreditsImage, getLogoImage, getLogoMobile }

export const AssetsService = {
  ...TenantAssetsService,
  getSvgIcon
}

export default AssetsService
